/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 18:16:15
 * @LastEditors: Json Chen
 * @LastEditTime: 2021-06-15 12:56:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/common.ts
 */

export enum EnumCollapseId {
  pageSetting = 'saleChannelContentContentPagePageSetting',
  iconStyle = 'saleChannelContentContentPageIconStyle',
  seoSetting = 'saleChannelContentContentPageSeoSetting',
  floatingBar = 'saleChannelContentContentPageFloatingActionsBar',
  miniProgramShare = 'saleChannelContentHomepageMiniProgramShare',
  miniProgramPageInfo = 'saleChannelContentHomepageMiniProgramInfo',
}

export const fixedCollapse = [
  EnumCollapseId.pageSetting,
  EnumCollapseId.iconStyle,
  EnumCollapseId.seoSetting,
  EnumCollapseId.floatingBar,
  EnumCollapseId.miniProgramShare,
  EnumCollapseId.miniProgramPageInfo,
];

export const generateDefaultSeoSetting = () => {
  return {
    title: '',
    description: '',
    urlSlug: '',
    slugValid: true,
  };
};
export const generateDefaultIconStyle = () => {
  return {
    colour: '#000000',
  };
};
export const generateDefaultPageSetting = () => {
  return {
    beginDate: null,
    beginTime: null,
    endDate: null,
    endTime: null,
    name: '',
    alwaysOn: true,
  };
};
export const generateDefaultFloatingActionsBar = () => {
  return {
    enable: true,
    backgroundColor: '#FFFFFF',
    iconColor: '#000000',
    expandable: true,
    expandableIcon: null,
    buttons: [],
  };
};
